import { toast } from "react-toastify";

// src/utils/sessionAlertHelper.js
let showSessionAlert = null;

export const setSessionAlertFunction = (fn) => {
  showSessionAlert = fn;
};

export const triggerSessionAlert = (message) => {
  localStorage.clear();
  toast.dismiss();
  if (showSessionAlert) {
    showSessionAlert(message);
  } else {
    console.warn("Session alert function not initialized.");
    window.location.href = "/signin";
  }
};
